export const getCurrentDateFormattedForStats = () => {
    return new Date().toISOString().substring(0, 10);
};
